<template>
	<div id="pageRoot">

		<div class="enciclopedia">
			<p class="textBaseCourier" id="text01">
				ENCICLOPEDIA
			</p>
			<p class="textBaseCourier" id="text02">
				LOS PERROS Y LOS SERES HUMANOS
			</p>
			<p class="textBaseCourier" id="text03">
				Hace muchos miles de años, los seres humanos vivían de forma muy diferente a la de ahora. Vivían en grupos, se desplazaban de un sitio a otro y se alimentaban de la caza, la pesca y la recolección de frutos.
			</p>

			<img id="imgDog" src="/pages/img/imgDogHuman.jpg">

			<p class="textBaseCourier" id="text04">
				SALIR JUNTOS A CAZAR
			</p>
			<p class="textBaseCourier" id="text05">
				En un momento de la historia de la humanidad, algunos lobos comenzaron a vivir cerca de los seres humanos. <span id="highlight">Humanos y lobos empezaron a salir juntos a cazar.</span>
			</p>
		</div>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<span class="footer-page footer-listen"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#text01
{
position: absolute;
width: 402px;
height: 78px;
left: 253px;
top: 59px;

font-size: 50px;
line-height: 55px;
text-align: center;
letter-spacing: 0.015em;

color: #231F20;
}
#text02
{
position: absolute;
width: 848px;
height: 51px;
left: 40px;
top: 158px;

font-weight: bold;
font-size: 47px;
line-height: 53px;

color: #231F20;
}
#text03
{
position: absolute;
width: 843px;
height: 133px;
left: 44px;
top: 219px;

font-size: 22px;
line-height: 33px;

color: #000000;
}
#text04
{
position: absolute;
width: 444px;
height: 51px;
left: 473px;
top: 382px;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text05
{
position: absolute;
width: 405px;
height: 198px;
left: 482px;
top: 436px;

font-size: 22px;
line-height: 33px;

color: #000000;
}
#highlight
{
text-decoration: underline;
}
#imgDog
{	
position: absolute;
width: 384px;
height: 274px;
left: 72px;
top: 388px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p84-85/V103.mp4"]
    }
  }
}
</script>